import React,{useState,useEffect} from 'react'
import {useForm} from 'react-hook-form'
import clinicService from '../../../../../services/clinic.service';
import userService from '../../../../../services/user.service';
import {useParams,useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'

const ClinicUserAdd = () => {
    
    const {register,handleSubmit,reset,formState:{errors}} = useForm();
    const {clinicId} = useParams();
    const navigate = useNavigate();
    const [roles,setRoles] = useState()

    useEffect(()=>{
        getRoles()
    },[])

   const getRoles = ()=>{
    userService.getRoles()
    .then(res=>{
        setRoles(res.data)
    })
    .catch(err=>{
        console.log(err)
    })
   }
    const onSubmit =(data,e)=>{
      
        const newData = {...data, secret:"ECXuserx1y1z1",clinicId:clinicId}

        userService.addUsers(clinicId,newData)
            .then(res=>{
                console.log("Added")
                e.target.reset();
                toast.success("Added New User",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            })
            .catch(err=>{
                console.log("error")
                toast.error("Error while adding new user",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            })
    }
    return ( 
        <>
         <h5 className="card-title">Add New User</h5>
            <div className="row">
                <div className="col-md-6">
                    <form onSubmit={handleSubmit(onSubmit)}>

                      <div className="form-group">
                        <label htmlFor="" className="form-label">First Name</label>
                        <input type="text" className="form-control mb-2"
                         aria-describedby="emailHelp" 
                         {...register("firstName",{required:true})}
                         placeholder="First Name"
                        />
                          {errors.firstName && <p>This is required</p>}
                      </div>
                      <div className="form-group">
                            <label htmlFor="" className="form-label">Last Name</label>
                                    <input 
                                        type="text" 
                                        className="form-control mb-2" 
                                        placeholder="Last Name" 
                                        {...register("lastName",{required:true})}
                                        />
                                         {errors.lastName && <p>This is required</p>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="" className="form-label">Email</label>
                                    <input 
                                        type="text" 
                                        className="form-control mb-2" 
                                        placeholder="Email" 
                                        {...register("email",{required:true})}
                                        />
                                         {errors.email && <p>This is required</p>}
                        </div>
                        <div className="form-group">
                                    <label htmlFor="exampleInputPassword1" className="form-label">Role</label>
                                   
                                    <select className="form-select" {...register("roleId",{required:true})}>
                                        {roles && roles.map((item)=>{
                                            return <option value={item.id}>{item.roleName}</option>
                                        })}
                                       
                                    </select>
                        </div>
                        <div className="form-group">
                                    <label htmlFor="exampleInputPassword1" className="form-label">Is Authenticated</label>
                                   
                                    <select className="form-select" {...register("isAuthenticated",{required:true})}>
                                      <option value="0">No</option>
                                       <option value="1">Yes</option>
                                      
                                    </select>

                        </div>
                        <div className="text-center mt-2">
                                    <button className="btn btn-primary me-2" type="submit">Submit</button>
                                    <button className="btn btn-secondary" type="reset">Reset</button>
                                </div>
                    </form>
                </div>
                <div className="col-md-4">
                        <div className="card text-bg-info">
                            <div className="card-body p-4">
                                <h5>Note:</h5>
                                <p> If you selected "isAuthenticated" to "Yes" Default password will be set to "ECXuserx1y1z1". However Edit user and do Reset Password request. This will send user an email to reset password on registered email. </p>
                            </div>
                        </div>
                </div>
            </div>
                           
                         
                      
        </>
     );
}
 
export default ClinicUserAdd;